/* Native modal focus, escape and top-layer behavior; no document-wide polling. */
if (!customElements.get('lunea-consultation')) {
  customElements.define('lunea-consultation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', event => {
        const trigger = event.target.closest('a[data-lp-consult-open], .lp-product__assurance-links .lp-product__policy-primary');
        if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open(trigger);
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target.closest('[data-lp-consult-close]')) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('change', () => this.syncPhone(), options);
      this.syncPhone();
      if (this.querySelector('[data-lp-consult-autopen]')) this.open();
    }
    syncPhone() {
      const phone = this.querySelector('[data-lp-consult-phone]');
      const choice = this.querySelector('input[name="contact[Consultation method]"]:checked');
      if (phone) phone.required = choice?.value === 'Phone consultation';
    }
    open(trigger) {
      if (this.dialog.open) return;
      this.opener = trigger || document.activeElement;
      const product = trigger?.closest('product-info') || document.querySelector('product-info.lp-editorial');
      if (product) {
        const title = product.dataset.lpProductTitle || product.querySelector('h1')?.textContent.trim() || '';
        const url = new URL(product.dataset.url || location.pathname, document.baseURI);
        const variant = product.querySelector('input.product-variant-id')?.value;
        if (variant) url.searchParams.set('variant', variant);
        const selected = [...product.querySelectorAll('variant-selects fieldset input:checked, variant-selects select')].map(input => input.value).join(' / ');
        [['Product', title], ['Product URL', url.href], ['Selected variant', variant || ''], ['Selected options', selected]].forEach(([key, value]) => {
          const field = this.querySelector(`[name="contact[${key}]"]`);
          if (field) field.value = value;
        });
        const message = `Hi Lunéa Paris, I would like help with ${title}.\n${selected}\n${url.href}`;
        const whatsapp = this.querySelector('[data-lp-consult-whatsapp]');
        const email = this.querySelector('[data-lp-consult-email]');
        if (whatsapp) whatsapp.href = `https://wa.me/13477408333?text=${encodeURIComponent(message)}`;
        if (email) email.href = `mailto:sales@luneaparis.co?subject=${encodeURIComponent(`Jewelry consultation — ${title}`)}&body=${encodeURIComponent(message)}`;
      }
      const timezone = this.querySelector('[name="contact[Timezone]"]');
      if (timezone) timezone.value = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      this.syncPhone();
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.querySelector('[data-lp-consult-heading]')?.focus({ preventScroll: true });
    }
    restore() {
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restore();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
